import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AmlSearcherService } from './services/aml-searcher.service';
import { BreadcrumbService } from '@src/app/shared/services/breadcrumb.service';

@Component({
  selector: 'app-aml-mercury-searcher',
  templateUrl: './aml-mercury-searcher.component.html',
  styleUrls: ['./aml-mercury-searcher.component.scss'],
  standalone: false,
})
export class AmlMercurySearcherComponent implements OnInit {
  public currentPage = 1;
  public itemsPerPage = 9;
  public paginatedData: any[] = [];
  // Holds the entire filtered dataset (passed to paginator)
  public dataFiltered: any[] = [];
  public originalData: any[] = [];
  public loadingTable = false;
  public pageSizes = [5, 10, 15, 20];
  public filter = '';
  public totalItems = 0;
  public maxPages = 0;
  public selectedPageSize: number;

  isAmlFolderAllowed = false;
  constructor(
    private breadcrumbService: BreadcrumbService,
    private cdr: ChangeDetectorRef,
    private amlSearcherService: AmlSearcherService
  ) {}

  ngOnInit(): void {
    this._buildBreadcrumb();
    this.getAllAmlEntries();
    const userLogged = localStorage.getItem('userLogged');
    if (userLogged) {
      console.log('userLogged: ', userLogged);
      try {
        const user = JSON.parse(userLogged);
        this.isAmlFolderAllowed =
          user?.role.name === 'Assistant' || user?.suiteRole === 'Superadmin';
      } catch (e) {
        this.isAmlFolderAllowed = false;
      }
    }
  }

  getAllAmlEntries() {
    this.loadingTable = true;
    this.amlSearcherService.getAmlDocs().subscribe(
      (res) => {
        this.originalData = res;
        // Initially no filter applied: empty dataset
        this.dataFiltered = [...this.originalData];
        this.totalItems = this.dataFiltered.length;
        this.maxPages = Math.ceil(this.totalItems / this.itemsPerPage);
        // this.updatePaginatedData();
        this.loadingTable = false;
      },
      (error) => {
        console.error('Error fetching AML Docs:', error);
        this.loadingTable = false;
      }
    );
  }

  private _buildBreadcrumb() {
    const breadcrumb = {
      title: [{ title: 'Buscador AML' }],
      breadcrumb: [],
    };
    this.breadcrumbService.sendBreadcrumb(breadcrumb);
  }

  searchFilter() {
    if (this.filter.trim().length > 0) {
      const filteredData = this.originalData.filter((item) => {
        return (
          (item.client_name &&
            item.client_name
              .toLowerCase()
              .includes(this.filter.toLowerCase())) ||
          (item.eng_code &&
            item.eng_code.toLowerCase().includes(this.filter.toLowerCase())) ||
          (Array.isArray(item.docs) &&
            item.docs.some(
              (doc) =>
                (doc.doc_individual &&
                  doc.doc_individual
                    .toLowerCase()
                    .includes(this.filter.toLowerCase())) ||
                (doc.doc_type &&
                  doc.doc_type
                    .toLowerCase()
                    .includes(this.filter.toLowerCase()))
            ))
        );
      });
      this.dataFiltered = filteredData;
      this.totalItems = this.dataFiltered.length;
      this.maxPages = Math.ceil(this.totalItems / this.itemsPerPage);
      this.paginatedData = this.dataFiltered.slice(0, this.itemsPerPage);
      this.currentPage = 1;
    } else {
      // Reset to full dataset when filter cleared
      this.dataFiltered = [...this.originalData];
      this.totalItems = this.dataFiltered.length;
      this.maxPages = Math.ceil(this.totalItems / this.itemsPerPage);
      this.paginatedData = this.dataFiltered.slice(0, this.itemsPerPage);
      this.currentPage = 1;
    }
    this.cdr.markForCheck();
  }

  handlePageChange(page: number): void {
    if (page < 1 || page > this.maxPages) return;
    this.currentPage = page;
    this.updatePaginatedData();
  }

  updatePaginatedData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    // Always slice from the current filtered dataset
    this.paginatedData = this.dataFiltered.slice(startIndex, endIndex);
    this.cdr.markForCheck();
  }

  updatePaginationSize(newPageSize: number) {
    this.selectedPageSize = newPageSize;
    this.itemsPerPage = newPageSize;
    this.currentPage = 1;
    // Recalculate maxPages and paginatedData with new size
    this.maxPages = Math.ceil(this.totalItems / this.itemsPerPage);
    this.updatePaginatedData();
  }

  navigateTo(item) {
    const url =
      'https://emeia-aml.ey.net/AML/IdentificationUpdate?ID=' +
      item.replace(/[A-Za-z]/g, '').trim();
    window.open(url, '_blank');
  }
}
